import React from "react";
import { Fonts } from "../../design/Font";
import ActiveSwitch from "../ActiveSwitch/ActiveSwitch";

//cardImage
import u118 from '../../images/hsa-dashboard/u118.png'

export default class CardDisplay extends React.Component{

    render(){
        const {status,name,card_number,expiration,cvv, onClick }=this.props
        
            return(
                <div style={{display:'flex', flexDirection:'row',}}>
                    <div><img src={u118} alt='u118'/></div>
                    <div style={{display:'flex', justifyContent:'space-evenly', width:"100%", alignItems:'center'}}>
                        <div  style={{display:'flex', flexDirection:'column'}}>
                            <span style={{...Fonts.text, color:"#666666",marginBottom:'0.6vh'}}>Status</span>
                            <ActiveSwitch onClick={onClick} value={status} />
                        </div>
                        <div style={{display:'flex', flexDirection:'column'}}>
                            <span style={{...Fonts.text, color:"#666666"}}>Name on the card</span>
                            <span style={{...Fonts.text, fontWeight:'bold', marginTop:'1.6vh'}}>{name}</span>
                        </div>
                        <div style={{display:'flex', flexDirection:'column'}}>
                            <span style={{...Fonts.text, color:"#666666"}}>Card Number</span>
                            <span style={{...Fonts.text, fontWeight:'bold', marginTop:'1.6vh'}}>{card_number}</span>
                        </div>
                        <div style={{display:'flex', flexDirection:'column'}}>
                            <span style={{...Fonts.text, color:"#666666"}}>Exp Date</span>
                            <span style={{...Fonts.text, fontWeight:'bold', marginTop:'1.6vh'}}>{expiration}</span>
                        </div>
                        <div style={{display:'flex', flexDirection:'column'}}>
                            <span style={{...Fonts.text, color:"#666666"}}>CVV</span>
                            <span style={{...Fonts.text, fontWeight:'bold', marginTop:'1.6vh'}}>{cvv}</span>
                        </div>
                    </div>
                </div>
            ) 
        
    }
}